import type {
  FriendlyError,
  FriendlyRecaptchaError,
  RecaptchaNonResetErrorName,
} from '../../../modules/Auth0/types';
import { recaptchaNonResetErrors } from '../../../modules/Auth0/utils/mapError';
import { captchaEvent } from '../../../modules/metrics';
import type { CaptchaEvent } from '../../../types';
import { track } from '../../../utils/datadog';

export interface RecaptchaSubmitProps {
  isBotCheckRequired: boolean;
  isBotCheckDone?: boolean;
  isRenderRecaptchaStarted?: boolean;
  isRenderRecaptchaDone?: boolean;
}

export const isNonResetRecaptchaError = (error: FriendlyError): boolean => {
  let errorRecaptchaRelated = false;
  Object.keys(recaptchaNonResetErrors).forEach((pwdkey) => {
    const mappedValue =
      recaptchaNonResetErrors[
        pwdkey as keyof Record<
          RecaptchaNonResetErrorName,
          FriendlyRecaptchaError
        >
      ];
    if (error === String(mappedValue)) {
      errorRecaptchaRelated = true;
    }
  });
  return errorRecaptchaRelated;
};

export const requireCloudflareBotCheck = (site: string): boolean =>
  site === 'seekAnz' || site === 'talent'; // enable only for seekAnz and talent sites

export const shouldRenderRecaptcha = (
  recaptchaScriptLoaded: boolean,
  isRecaptchaRequired: boolean,
  isRenderRecaptchaStarted?: boolean,
): boolean =>
  recaptchaScriptLoaded && isRecaptchaRequired && !isRenderRecaptchaStarted;

export const logError = (err: Error, message: CaptchaEvent) => {
  track(err);
  captchaEvent(message);
};

export const escapeSubmit = ({
  isBotCheckRequired,
  isBotCheckDone,
  isRenderRecaptchaStarted,
  isRenderRecaptchaDone,
}: RecaptchaSubmitProps) => {
  if (isBotCheckRequired && !isBotCheckDone) return true;
  if (isRenderRecaptchaStarted && !isRenderRecaptchaDone) return true;
  return false;
};
